import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { accessTokenStorage } from '../../storage/auth/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useLogout = ({ reloadWindow = true }: { reloadWindow?: boolean } = {}) => {
  const queryClient = useQueryClient();
  const { mutate: logoutUser, isPending } = useAppMutation([QueryKey.GET_LOGOUT], {
    mutationFn: () => ApiService.delete({ endpoint: BackendRoute.AUTH_LOGOUT }),
    onSuccess: () => {
      accessTokenStorage.getState().delete();
      queryClient.clear();
      reloadWindow && window.location.reload();
    },
  });
  return { logoutUser, isPending };
};
